import { Dropdown } from 'primereact/dropdown';
import { FC, useEffect } from 'react';
import { DropdownItemModel } from '../../../../pages/SingleUnit';
import { ReportData, ReportGroupBy, ReportOrderBy } from '../../../../models/Report';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { getStandardBySites } from '../../../../graphQLOperations/ReportHub';
import { ReportHubGetStandardsBySitesQuery } from '../../../../graphQLOperations/__generated__/ReportHubGetStandardsBySitesQuery.graphql';
import { sortByKey } from '../../../../businessLogicService/sortCriteria';

interface Props {
  values: ReportData;
  setValues: (values: ReportData) => void;
  standards: DropdownItemModel[];
  setStandards: (standards: DropdownItemModel[]) => void;
  queryStandardsReference: PreloadedQuery<ReportHubGetStandardsBySitesQuery, Record<string, unknown>>;
}

const ReportHubModalGroupByFilter: FC<Props> = ({
  values,
  setValues,
  standards,
  setStandards,
  queryStandardsReference,
}) => {
  const queryData = usePreloadedQuery<ReportHubGetStandardsBySitesQuery>(getStandardBySites, queryStandardsReference);

  useEffect(() => {
    const filteredStandardStates = queryData.sites?.nodes?.flatMap(site =>
      site && site.standardState
        ? {
            value: site.standardState.id || '',
            label: `${site.standardState.stateStandardName || ''} - ${site.name || ''}`,
          }
        : [],
    );

    filteredStandardStates?.sort(sortByKey('label'));
    setStandards(filteredStandardStates as DropdownItemModel[]);

    if (filteredStandardStates?.length === 1) {
      setValues({ ...values, standards: filteredStandardStates[0].value });
    }
  }, [queryData]);

  return (
    <>
      {standards?.length > 1 ? (
        <div className="field col-12 mb-1">
          <label htmlFor="classes">State Standard*</label>
          <Dropdown
            value={values.standards}
            optionLabel="label"
            id="standards"
            className="w-full"
            filter
            onChange={e => setValues({ ...values, standards: e.target.value })}
            options={standards}
          />
        </div>
      ) : (
        <></>
      )}
      <div className="flex flex-row justify-content-between">
        <div className="flex flex-column ml-4">
          <label className="col-12" style={{ fontFamily: 'Poppins' }}>
            Grouped By:
          </label>
          <label htmlFor="grouped1" className="flex flex-row">
            <input
              style={{ height: '20px', width: '20px' }}
              type="radio"
              id="grouped1"
              name="Grouped By"
              value={ReportGroupBy.UNIT}
              onChange={() => setValues({ ...values, groupedBy: ReportGroupBy.UNIT })}
              checked={values.groupedBy === ReportGroupBy.UNIT}
            />
            <p className="ml-2 mt-0 " style={{ fontFamily: 'Poppins', cursor: 'pointer' }}>
              Unit
            </p>
          </label>
          <label htmlFor="grouped2" className="flex flex-row">
            <input
              style={{ height: '20px', width: '20px' }}
              type="radio"
              id="grouped2"
              name="grouped"
              value={ReportGroupBy.STANDARD}
              onChange={() => setValues({ ...values, groupedBy: ReportGroupBy.STANDARD })}
              checked={values.groupedBy === ReportGroupBy.STANDARD}
            />
            <p className="ml-2 mt-0 " style={{ fontFamily: 'Poppins', cursor: 'pointer' }}>
              Standards
            </p>
          </label>
        </div>
        <div className="flex flex-column mr-4">
          <label className="col-12" style={{ fontFamily: 'Poppins' }}>
            Students:
          </label>
          <label htmlFor="grouped3" className="flex flex-row">
            <input
              style={{ height: '20px', width: '20px' }}
              type="radio"
              id="grouped3"
              name="order"
              value={ReportOrderBy.ROWS}
              onChange={() => setValues({ ...values, orderBy: ReportOrderBy.ROWS })}
              checked={values.orderBy === ReportOrderBy.ROWS}
            />
            <p className="ml-2 mt-0 " style={{ fontFamily: 'Poppins', cursor: 'pointer' }}>
              in rows
            </p>
          </label>
          <label htmlFor="grouped4" className="flex flex-row">
            <input
              style={{ height: '20px', width: '20px' }}
              type="radio"
              id="grouped4"
              name="order"
              value={ReportOrderBy.COLUMNS}
              onChange={() => setValues({ ...values, orderBy: ReportOrderBy.COLUMNS })}
              checked={values.orderBy === ReportOrderBy.COLUMNS}
            />
            <p className="ml-2 mt-0 " style={{ fontFamily: 'Poppins', cursor: 'pointer' }}>
              in columns
            </p>
          </label>
        </div>
      </div>
    </>
  );
};

export default ReportHubModalGroupByFilter;
